import {createAction} from '@ngrx/store';


export class UploadLogoDialogActions {

    public static open = createAction(
      '[Fakturierungsbeleg-Form] Open upload logo dialog.',
    );

    public static close = createAction(
      '[Fakturierungsbeleg-Form] Close upload logo dialog.',
    );
}
